export const getAgentInfo = (t: (key: string) => string, agentName?: string, provisionReceiver?: string) => `${agentName || t('portfolio.createNewPortfolio.agentInformation.unknown')} / ${provisionReceiver || t('portfolio.createNewPortfolio.agentInformation.unknown')}`;

export const joinWithSeparator = (separator: string, ...args: Array<string | undefined | null>) => {
    const items = args?.filter(f => !!f);

    if (items?.length) {
        return items.join(separator);
    }

    return '-';
};
